import * as React from "react";

const SvgWind = (props) => (
  <svg
    viewBox="0 0 80 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M44.944.421c-4.957 0-8.989 3.938-8.989 8.778h5.393c0-1.936 1.613-3.51 3.596-3.51 1.982 0 3.595 1.574 3.595 3.51 0 1.936-1.613 3.512-3.595 3.512H7.19v5.266h37.753c4.956 0 8.988-3.937 8.988-8.778 0-4.84-4.032-8.778-8.988-8.778Z"
      fill="currentColor"
    />
    <path
      d="M67.416 2.177c-5.452 0-9.888 4.332-9.888 9.656 0 3.872 3.226 7.022 7.191 7.022s7.191-3.15 7.191-7.022h-5.393c0 .968-.807 1.756-1.798 1.756s-1.798-.788-1.798-1.756c0-2.42 2.016-4.39 4.494-4.39 3.966 0 7.191 3.151 7.191 7.023 0 3.873-3.225 7.023-7.19 7.023H0v5.267h67.416c6.939 0 12.584-5.514 12.584-12.29C80 7.69 74.355 2.177 67.416 2.177ZM53.933 30.267H7.19v5.267h46.741c2.479 0 4.495 1.969 4.495 4.389s-2.016 4.389-4.495 4.389c-2.478 0-4.494-1.97-4.494-4.39h-5.393c0 5.325 4.435 9.657 9.887 9.657 5.453 0 9.888-4.332 9.888-9.656 0-5.325-4.435-9.656-9.887-9.656Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgWind;
